var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "box view-nav-bar" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center w-100" },
          [
            _c(
              "div",
              { staticClass: "flex-grow-1" },
              [
                _c(
                  "router-link",
                  { staticClass: "mr-3", attrs: { to: "/admissions/movie" } },
                  [
                    _c("icon", { attrs: { name: "chevron-left" } }),
                    _vm._v(" Back\n                "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.bucket.title || "Movix " + _vm.movixId)),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "text-muted ml-2" },
                  [
                    _vm._v("\n                    — Movix "),
                    _c("movix-link", { attrs: { id: _vm.movixId } }),
                    _vm._v(" "),
                    _vm.bucket.movie_tag
                      ? _c("span", [
                          _vm._v(" · " + _vm._s(_vm.bucket.movie_tag)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bucket.released_at
                      ? _c("span", [
                          _vm._v(
                            " · released " + _vm._s(_vm.bucket.released_at)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bucket.imdb_id
                      ? _c("span", [
                          _vm._v(" · "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.imdb.com/title/" +
                                  _vm.bucket.imdb_id,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v(_vm._s(_vm.bucket.imdb_id))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm btn-outline-secondary",
                attrs: { to: "/history/" + _vm.movixId },
              },
              [_vm._v("History")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("Loading…")]
            ),
          ])
        : !_vm.totals.weeks
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [
                _vm._v(
                  "No admissions found for Movix id " +
                    _vm._s(_vm.movixId) +
                    "."
                ),
              ]
            ),
          ])
        : [
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "box-content" }, [
                _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.formatInt(_vm.totals.admissions))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatInt(
                              _vm.totals.admissions / _vm.totals.weeks
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [_vm._v("100%")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totals.weeks)),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.totals.first_week) +
                            " – " +
                            _vm._s(_vm.totals.last_week)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.totals.peak_week))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totals.cinemas)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(_vm.formatInt(_vm.totals.admissions_preshow))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatInt(
                              _vm.totals.admissions_preshow / _vm.totals.weeks
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totals.pct_preshow !== null
                              ? _vm.totals.pct_preshow + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "4" } }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: {
                      upper: "Active weeks",
                      lower: _vm.weeks.length + " cinema weeks with admissions",
                      border: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.weeks, function (week, index) {
                        return _c("tr", { key: week.week_code }, [
                          _c("td", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/admissions/year/" +
                                      week.week_code.substr(0, 4) +
                                      "/" +
                                      week.week_code,
                                  },
                                },
                                [_vm._v(_vm._s(week.week_code))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-muted" }, [
                            week.week_start
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(week.week_start) +
                                      " – " +
                                      _vm._s(week.week_end)
                                  ),
                                ])
                              : _c("span", [_vm._v("—")]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(week.cinemas)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.formatInt(week.admissions))),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.pct(week.admissions, _vm.totals.admissions)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "progress",
                                staticStyle: { height: "8px" },
                                attrs: {
                                  title: _vm.formatInt(week.admissions),
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "progress-bar",
                                  style: { width: _vm.barWidth(week) + "%" },
                                  attrs: { role: "progressbar" },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(_vm.formatInt(week.admissions_preshow))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                week.pct_preshow !== null
                                  ? week.pct_preshow + "%"
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  week.real_weighted != null
                                    ? week.real_weighted + "%"
                                    : "—"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            week.real_weighted != null &&
                            week.real_weighted <= 90
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "badge badge-warning ml-1",
                                    attrs: {
                                      title:
                                        "Minimum real: " + week.real_min + "%",
                                    },
                                  },
                                  [_vm._v("⚠")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                    _vm._v("\n                    One row per "),
                    _c("code", [_vm._v("week_code")]),
                    _vm._v(" with an "),
                    _c("code", [_vm._v("admissions_week")]),
                    _vm._v(
                      " row for this Movix id, all sales houses;\n                    "
                    ),
                    _c("strong", [_vm._v("Preshow")]),
                    _vm._v(" = rows with "),
                    _c("code", [_vm._v("saleshouse = BF")]),
                    _vm._v(". "),
                    _c("strong", [_vm._v("Real %")]),
                    _vm._v(
                      " is the\n                    admissions-weighted average of "
                    ),
                    _c("code", [_vm._v("real")]),
                    _vm._v(
                      ": 97.5 = fully compiled from Cinedata, lower = partly estimated.\n                    Same data as JSON: "
                    ),
                    _c("code", [
                      _vm._v(
                        "GET /api/v1/admissions/movie/" + _vm._s(_vm.movixId)
                      ),
                    ]),
                    _vm._v(".\n                "),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: {
                      upper: "Source titles",
                      lower:
                        _vm.titles.length +
                        " Cinedata titles mapped to this movie",
                      border: "",
                    },
                  }),
                  _vm._v(" "),
                  _vm.titles.length
                    ? _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.titles, function (title) {
                            return _c("tr", { key: title.source_title }, [
                              _c("td", [
                                _c("code", [
                                  _vm._v(_vm._s(title.source_title)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(title.days)),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(title.cinemas)),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(_vm.formatInt(title.admissions))),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.pct(
                                      title.admissions,
                                      _vm.titlesAdmissions
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(title.first_day))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(title.last_day))]),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _c("p", { staticClass: "text-muted small mb-0" }, [
                        _vm._v(
                          "\n                    No daily rows: the weekly admissions of this movie are estimated or were imported from the legacy archive.\n                "
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.titles.length
                    ? _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                        _vm._v(
                          "\n                    The titles as reported by Cinedata in "
                        ),
                        _c("code", [_vm._v("admissions_day")]),
                        _vm._v(
                          ", before mapping to a Movix id.\n                    Daily admissions are without the 2.5% free-ticket multiplier and without estimated weeks, so\n                    they do not add up to the weekly total above.\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of all"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-200" }, [_vm._v("First – last week")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Peak week")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("Max cinemas"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("All sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("every sales house"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("Preshow sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("sales house BF"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-50" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Week")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-200" }, [_vm._v("Dates")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Cinemas"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of movie"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-200" }),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow (BF)"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("Preshow %"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Source title")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Days")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Cinemas"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of movie"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("First day")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Last day")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }